export enum CryptoCurrencyType {
    Bitcoin,
    Ethereum
}